"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var AppBarSearch = /** @class */ (function (_super) {
    tslib_1.__extends(AppBarSearch, _super);
    function AppBarSearch(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setInputRef = function (el) {
            _this.$input = el;
        };
        _this.onChange = function (e) {
            var onSearch = _this.props.onSearch;
            var query = e.target.value;
            _this.setState({
                query: query
            });
            onSearch(query);
        };
        _this.onOpen = function () {
            var onOpen = _this.props.onOpen;
            _this.setState({
                isOpen: true
            }, _this.focusInput);
            onOpen && onOpen();
        };
        _this.focusInput = function () {
            _this.$input.focus();
        };
        _this.onClose = function () {
            var onClose = _this.props.onClose;
            _this.setState({
                query: "",
                isOpen: false
            });
            onClose && onClose();
        };
        _this.state = { query: "", isOpen: false };
        return _this;
    }
    AppBarSearch.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, width = _a.width, onClose = _a.onClose, onOpen = _a.onOpen, onSearch = _a.onSearch, onChange = _a.onChange, others = tslib_1.__rest(_a, ["theme", "className", "width", "onClose", "onOpen", "onSearch", "onChange"]);
        var triggerClasses = classnames_1.default(theme.trigger);
        var barClasses = classnames_1.default(theme.search, className);
        var _b = this.state, query = _b.query, isOpen = _b.isOpen;
        var styles = {
            width: utils_1.toREMString(width)
        };
        return (React.createElement("div", { className: theme.root }, isOpen ? (React.createElement("div", { className: barClasses, style: styles },
            React.createElement(icon_1.Icon, { iconName: "icon-search-small", size: 1.8 }),
            React.createElement("input", tslib_1.__assign({ ref: this.setInputRef }, others, { value: query, onChange: this.onChange })),
            React.createElement("div", { className: theme.close, onClick: this.onClose },
                React.createElement(icon_1.Icon, { iconName: "icon-cancel-small", size: 1 })))) : (React.createElement("div", { className: triggerClasses, onClick: this.onOpen },
            React.createElement(icon_1.Icon, { iconName: "icon-search-small", size: 2.2 })))));
    };
    AppBarSearch.defaultProps = {
        width: 28,
        placeholder: "Search..."
    };
    return AppBarSearch;
}(React.Component));
exports.default = AppBarSearch;
